import React from "react";
import clsx from "clsx";

import { Modal as ModalCore, IModalProps as IModalPropsCore } from "@webbio/components";
import IcnClose from "@assets/icons/close-2.svg";

import { IconComponent } from "../icon";
import styles from "./better-modal.module.scss";

export interface IBetterModalProps extends IModalPropsCore {
  isHidden?: boolean;
  noHeader?: boolean;
  noCloseIcon?: boolean;
}

const BetterModal = ({ noHeader, noCloseIcon, ...props }: IBetterModalProps): JSX.Element => {
  return (
    <ModalCore
      propStyles={styles}
      closeIcon={<IconComponent icon={IcnClose} size="24px" />}
      className={clsx(
        props.className,
        props.isHidden && styles.hide,
        noHeader && styles.noHeader,
        noCloseIcon && styles.noCloseIcon
      )}
      {...props}
    >
      {props.children}
    </ModalCore>
  );
};

export { BetterModal };
